module.exports = __webpack_public_path__ + "static/media/OronMFW-Medium.0d3bd5d0.ttf";